var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"delete-container"},[_c('button',{attrs:{"id":"delete-button"},on:{"click":_vm.deleteCollection}},[_vm._v("DELETE COLLECTION")])])
}
var staticRenderFns = []

export { render, staticRenderFns }